import { type GuardArgs } from 'xstate5/dist/declarations/src/guards';

import { type ScanToPayContext } from './scan-to-pay.machine.context';
import { type ScanToPayEvents } from './scan-to-pay.machine.events';

// ─── Guards ──────────────────────────────────────────────────────────────────

const shouldFetchPaymentToken: Guard = ({ context }) => {
  return Boolean(context.paymentMethodId);
};

export const ScanToPayGuards = {
  shouldFetchPaymentToken,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard = (args: GuardArgs<ScanToPayContext, ScanToPayEvents>) => boolean;
